<template>
  <div class="original-exam">
    <v-base-card>
      <template v-slot:heading>
        進学教材テスト作成条件
      </template>

      <template v-slot:content>
        <v-container fluid>
          <v-row>
            <v-col cols="3">
              <v-select
                class="select"
                v-model="selectedSubject"
                :items="subjects"
                item-text="name"
                item-value="id"
                label="教科"
              ></v-select>
            </v-col>
            <v-col cols="1">
              <v-btn class="mt-2" color="secondary" @click="search" :disabled="disabled">絞込み</v-btn>
            </v-col>
          </v-row>
          <v-row v-if="presets.length != 0" class="px-0">
            <v-col lg="3" md="3" sm="4" v-for="preset in presets" :key="preset.id">
              <v-clickable-card
                elevation="2"
                style="max-width: 250px"
                :detail="preset.detail"
                @click="settingMaxPoint(preset)"
              >
                <template v-slot:heading>
                  <v-list-item-content>
                    <v-list-item-title class="text-center heading">{{preset.title}}</v-list-item-title>
                  </v-list-item-content>
                </template>

                <template v-slot:content>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <th class="text-center pl-1 py-2">教科</th>
                          <td class="text-center pl-1 py-2">
                            {{ preset.subject }}
                          </td>
                        </tr>
                        <tr>
                          <th class="text-center pl-1 py-2 th_bottom">設問数</th>
                          <td class="text-center pl-1 py-2 td_bottom" v-html="preset.questionNum" />
                        </tr>
                        <tr>
                          <th class="text-center pl-1 py-2 th_bottom">使用問題</th>
                          <td class="text-center pl-1 py-2 td_bottom" v-html="preset.materialNames" />
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </template>
              </v-clickable-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1">
              <v-btn class="mt-2" color="secondary" @click="rangeSettingDialog = true">オリジナル範囲設定はコチラ</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-base-card>

    <!-- 配点設定用のモーダル -->
    <v-dialog v-model="dialog" persistent max-width="400px">
      <v-card>
        <v-toolbar
          class="title"
        >配点を選択してください</v-toolbar>
        <!-- <v-card-title>
          <span class="headline">配点を選択してください</span>
        </v-card-title> -->
        <v-card-text>
          <v-choice-max-point/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" class="dialog-Button" text @click="dialogCancel">キャンセル</v-btn>
          <v-btn color="blue darken-1" class="dialog-Button" text @click="dialogNext" :disabled="!nextFlg">次へ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 範囲設定用のモーダル -->
    <v-dialog v-model="rangeSettingDialog" persistent max-width="600px">
      <v-card>
        <v-toolbar
          class="title"
        >プリセットを使用せずに作成</v-toolbar>
        <v-card-text style="padding-top: 10px;">
          <span class="shingaku__message">※進学教材の単元番号を入力してください。（例：1-12）</span><br>
          <span class="shingaku-attention__message">※著作権の都合上、問題が登録されていない単元がございます。</span>
          <v-shingaku-unit-range-group/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" class="dialog-Button" text @click="rangeSettingDialog = false">閉じる</v-btn>
          <v-btn color="blue darken-1" class="dialog-Button" text @click="dialogOpen();rangeSettingDialog = false" :disabled="searchFlg">検索</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VClickableCard from '@/components/molecules/ClickableCard'
import VChoiceMaxPoint from '@/components/molecules/ChoiceMaxPoint'
import VShingakuUnitRangeGroup from '@/components/molecules/ShingakuUnitRangeGroup'
import config from '../../config'

export default {
  components: {
    VBaseCard,
    VClickableCard,
    VChoiceMaxPoint,
    VShingakuUnitRangeGroup ,
  },

  data: () => ({
    selectedTextbook: '',
    presets: [],
    dialog: false,
    selectedPreset: [],
    rangeSettingDialog: false,
  }),

  mounted() {
    this.search()
  },

  computed: {
    selectedSubject: {
      get() {
        return this.$store.state.top.selectedSubject?.id;
      },
      set(value) {
        const subject = this.subjects.find(subject => subject.id === value)
        this.$store.commit('setSelectedSubject', {
          subject: subject
        })
        this.setCurrentSubjectCondition()
      }
    },
    disabled() {
      return (this.selectedSubject === '')
    },
    subjects() {
      // アカウントごとの担当教科を返す
      const accountSubjectIds = this.$store.state.top.subjectTeachers.map(subjectTeacher => subjectTeacher.subject.id)
      return this.$store.state.master.allSubjects.filter(subject => subject.ancestryDepth === 0 && accountSubjectIds.includes(subject.id))
    },
    nextFlg() {
      return this.$store.state.top.selectedMaxPoint && !this.$store.state.top.selectedMaxPoint.match(/[^0-9]/)
    },
    searchFlg() {
      return this.$store.state.top.currentSubjectCondition.shinkenkyuUnitRanges.filter(range => range.start && range.end && !range.error).length === 0
    },
  },

  methods: {
    async search() {
      this.$app.$refs.loading.open({message: '検索中'})
      this.presets = []
      // 検索API実行
      let params = `?q[subject_id_eq]=${this.selectedSubject}&q[is_shingaku_eq]=true`
      const res = await this.$axios('/api/v1/teacher/presets' + params)

      // プリセットが見つからなかったらその旨表示
      if (!res.data.length) {
        this.$toasted.global.error({ message: 'プリセットがありません' })
        this.$app.$refs.loading.close({})
        return false
      }

      res.data.forEach(item => {
        this.presets.push(this.$store.getters['sheet/convertPresetData'](item))
      })

      this.$app.$refs.loading.close({})
    },

    settingMaxPoint(preset) {
      this.selectedPreset = preset
      this.dialogOpen()
    },
    dialogOpen() {
      this.dialog = true
    },
    dialogCancel() {
      this.dialog = false
      this.selectedPreset = []
    },
    dialogNext() {
      this.dialog = false
      if (this.selectedPreset && this.selectedPreset.id) {
        this.showDetail(this.selectedPreset)
      } else {
        this.dialogSearch()
      }
    },
    setCurrentSubjectCondition() {
      let currentSubject = this.$store.state.master.allSubjects.find(subject => subject.id === this.selectedSubject)
      if (currentSubject.code === 'sh') {
        currentSubject = this.$store.state.master.allSubjects.find(subject => subject.code === 'ch1')
      }
      this.$store.commit(
        'setCurrentSubjectCondition',
        {
          currentSubjectCondition: this.$store.state.top.allConditions
            .find(condition => condition.code === currentSubject.code)
        }
      )
    },

    async showDetail(preset) {
      this.$app.$refs.loading.open({message: '処理中です。少々お待ちください。'})
      const subject = this.$store.state.master.allSubjects.find(x => x.id == this.selectedSubject)
      this.$store.commit('setSelectedSubject', { subject: subject } )
      await this.$store.dispatch('initializeAllConditions')
      preset.details.forEach(detail => {
        // 社会と技能教科の場合は分野をセット
        if (config.hasOptionSubjects.includes(preset.subjectCode)) {
          const option = this.$store.state.master.allSubjects.find(x => x.code === detail.subject_code)
          this.$store.commit('addSelectedShakaiOptions', { option: option })
        }

        this.$store.commit(
          'setCurrentSubjectCondition',
          {
            currentSubjectCondition: this.$store.state.top.allConditions
              .find(condition => condition.code === detail.subject_code)
          }
        )

        const publisher = subject.publishers.find(x => x.name == detail.publisher_name)
        const ranges = preset.rangeData.find(x => x.subjectCode === detail.subject_code)?.ranges || []

        this.$store.commit('changeCurrentSubjectCondition', {
          selectedPublisher: publisher,
          publisherPages: ranges.map(range => ({ start: String(range[0]), end: String(range[1]) })),
          questionNum: String(detail.question_cnt)
        })
      })

      const params = {
        "sheet": { id: this.$store.state.sheet.sheetContentPages?.id },
        "preset_id": preset.id,
        "subject_id": this.selectedSubject,
        "selected_max_point": this.$store.state.top.selectedMaxPoint,
        "restartSheets": null,
        "sheet_type": 'shingaku'
      }
      await this.$store.dispatch('sheet/getSheetContents', params)
      //問題作成再開処理用にプリセットIDを保存
      this.$store.commit('sheet/setSheetSearchCondition', {
        sheetSearchCondition: params
      })
      this.$app.$refs.loading.close()
      // 画面遷移

      this.$store.commit('sheet/setSheetType', {
        sheetType: 'shingaku'
      })

      this.$router.push('/teacher/change')
    },
    async dialogSearch() {
      this.rangeSettingDialog = false
      this.$app.$refs.loading.open({type: 'print', message: '問題検索中です'})
      const subjectId = this.$store.state.top.selectedSubject?.id
      const conditions = this.$store.getters.sendApiParams.reduce((accumulator, condition) => {
        const selectedSubject = this.$store.state.master.allSubjects.find(x => x.code == condition.code)
        accumulator.push({
          subject_id: Number(selectedSubject?.id),
          shinkenkyu_unit_ranges: condition.shinkenkyuUnitRanges.map(range => { return { start: Number(range.start), end: Number(range.end) } }),
          question_num: 60,
          difficulty_id: 99,
          selected_max_point_value: this.$store.state.top.selectedMaxPointValue,
          selected_max_point: this.$store.state.top.selectedMaxPoint,
          athletic_event_ids: [],
        })
        return accumulator
      }, [])

      const subjectTeacherId = this.$store.state.top.subjectTeachers.find(subjectTeacher => {
          return (subjectTeacher.subject.id === subjectId)
        })?.id
      const params = {
        sheet: {
          id: this.$store.state.sheet.sheetContentPages?.id,
          subject_teacher_id: subjectTeacherId,
          step: config.step.REPLACE_CONTENT, // STEP（再開時に必要）
          sheet_type: 'shingaku',
          search_conditions: conditions      // 検索条件保存用（再開時に必要）
        },
        conditions: conditions
      }
      await this.$store.dispatch('sheet/getSheetContents', params)
        .then(() => {
          this.$app.$refs.loading.close()

          this.$store.commit('sheet/setSheetType', {
            sheetType: 'shingaku'
          })

          this.$router.push('/teacher/change')
        })
        .catch(() => {
          this.$app.$refs.loading.close()
        })

      this.$store.commit('sheet/setSheetSearchCondition', {
        sheetSearchCondition: conditions
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
th
  width 80px
  background-color #efefef
  font-size 12px !important

td
  background-color white !important;
  font-size 12px !important

.th
  &_top
    border-top #3872b0 2px solid
  &_bottom
    border-bottom #d6d6d6 1px solid

.td
  &_top
    border-top #d6d6d6 2px solid
  &_bottom
    border-bottom #d6d6d6 1px solid

.select
  font-size: 14px !important;

.heading
  font-size: 14px !important;

.exams-alert
  color:#FF0000;
  font-weight:bold;

.attention__message
  font-size 12px
  color #FF0000

.title
  justify-content center
  background-color: #2a5594 !important
  color white

.shingaku
  &__message
    font-size 14px
    font-weight bold

  &-attention__message
    font-size 14px
    color #FF0000
    font-weight bold

</style>
